import React from "react";
import { SimpleHeader } from "./SimpleHeader";

interface AirportHeaderProps {
  airport: server.dto.Airport
}

export const AirportHeader = ({ airport }: AirportHeaderProps) =>
  <SimpleHeader title={airport.name} isDeleted={false}>
    <div className="purple-header-text">{airport.cityCountry}</div>
  </SimpleHeader>;
